import React from 'react';
import ReactRenderer from 'react-dom';
import RubikCubeApplication from './components/App';
import './index.css';

const applicationRootElement = document.getElementById('root');

ReactRenderer.render(
  <RubikCubeApplication />,
  applicationRootElement
);
